// extracted by mini-css-extract-plugin
module.exports = {"maxWidthSmallScreenDesktop":"960px","option":"SiblingProductButton_option__MhyYi","option__selected":"SiblingProductButton_option__selected__GF_2m"};